import { Component, OnInit } from "@angular/core";
import { CommonModule } from "@angular/common";
import { LandingService } from "../../services/Landing_Services/landing.service";
import { DomSanitizer, SafeHtml } from "@angular/platform-browser";

interface ServiceItem {
  title: string;
  description: SafeHtml | string;
  icon: string;
  slug: string;
}

@Component({
  selector: "app-services",
  standalone: true,
  imports: [CommonModule],
  templateUrl: "./services.component.html",
  styleUrl: "./services.component.css",
})
export class ServicesComponent implements OnInit {
  services: ServiceItem[] = [
    {
      title: "No data to show",
      description: "No data to show",
      icon: "M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z",
      slug: "ip-phone",
    },
    {
      title: "No data to show",
      description: "No data to show",
      icon: "M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10",
      slug: "ip-pbx",
    },
    {
      title: "No data to show",
      description: "No data to show",
      icon: "M17 8h2a2 2 0 012 2v6a2 2 0 01-2 2h-2v4l-4-4H9a1.994 1.994 0 01-1.414-.586m0 0L11 14h4a2 2 0 002-2V6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2v4l.586-.586z",
      slug: "call-center",
    },
    {
      title: "No data to show",
      description: "No data to show",
      icon: "M5 12h14M5 12a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v4a2 2 0 01-2 2M5 12a2 2 0 00-2 2v4a2 2 0 002 2h14a2 2 0 002-2v-4a2 2 0 00-2-2m-2-4h.01M17 16h.01",
      slug: "hosted-service",
    },
    {
      title: "No data to show",
      description: "No data to show",
      icon: "M7 20l4-16m2 16l4-16M6 9h14M4 15h14",
      slug: "short-code-service",
    },
    {
      title: "No data to show",
      description: "No data to show",
      icon: "M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z",
      slug: "secure-data-connectivity",
    },
  ];

  constructor(
    private landingService: LandingService,
    private sanitizer: DomSanitizer,
  ) {}

  ngOnInit(): void {
    this.services.forEach((service, index) => {
      this.landingService.getPageBySlug(service.slug).subscribe({
        next: (page) => {
          if (page && page.title && page.title.trim() !== "") {
            this.services[index].title = page.title;
          } else {
            this.services[index].title = "No data to show";
          }

          if (page && page.description) {
            let textDesc = "";
            if (typeof DOMParser !== "undefined") {
              const parser = new DOMParser();
              const doc = parser.parseFromString(page.description, "text/html");
              textDesc = doc.body.textContent || "";
            } else {
              textDesc = page.description.replace(/<[^>]*>/g, "");
            }
            this.services[index].description = textDesc.trim()
              ? textDesc.trim()
              : "No data to show";
          } else {
            this.services[index].description = "No data to show";
          }
        },
        error: (error) => {
          console.error(`Error loading page for slug ${service.slug}:`, error);
          this.services[index].title = "No data to show";
          this.services[index].description = "No data to show";
        },
      });
    });
  }
}
